(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      var initializeRecommendationImages = function(attempt) {
        if (window.theme && theme.ProductBlockManager && typeof theme.ProductBlockManager.loadImages === 'function') {
          theme.ProductBlockManager.loadImages(productRecommendationsSection);
          if (typeof theme.initAnimateOnScroll === 'function') {
            theme.initAnimateOnScroll();
          }
        } else if (attempt < 20) {
          window.setTimeout(function() { initializeRecommendationImages(attempt + 1); }, 50);
        }
      };
      initializeRecommendationImages(0);

      // Yotpo star ratings are injected with the AJAX-loaded recommendations.
      var initializeRecommendationRatings = function(attempt) {
        if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
          window.yotpoWidgetsContainer.initWidgets();
        } else if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
          window.yotpo.initWidgets();
        } else if (attempt < 40) {
          window.setTimeout(function() { initializeRecommendationRatings(attempt + 1); }, 100);
        }
      };
      initializeRecommendationRatings(0);
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
